module.exports = __webpack_public_path__ + "static/media/galleryImg27.ff4624d5.jpg";